<div *ngIf="expanded">
  <div class="cell__expanded-goal">
    <div class="cell__goal">
      <div>
        <a *ngFor="let unidad of meta.unidades; let i = index"
          [routerLink]="['/estudio/unidad', unidad.id]">{{i === meta.unidades.length - 1 ? unidad.nombre : unidad.nombre + ', '}}</a>
      </div>
      <h4 class="mat-h4">Descripción completa de la meta</h4>
      <p>{{(meta.txtFR.length > 0 ? meta.txtFR : meta.txtEN.length > 0 ? meta.txtEN : meta.txtES) |
      HTMLEntitiesCleaner}}</p>
    </div>
    <div class="cell__student">
      <div *ngIf="meta.alumnosPendientes">
        <h4 class="mat-h4">Alumnos con <em>no aprobado</em> o <em>pendiente</em></h4>
        <div *ngFor="let alumno of meta.alumnosPendientes">
          <p>
            <strong>{{alumno.apellidosNombres}}</strong>
            <br>
            {{alumno.evaluacionNickname}}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>